import React, { useMemo } from "react";
import format from "date-fns/format";

import { FORMAT_DATE } from "constants/time";

import styles from "./styles.module.scss";

const AvailableDateData = ({ content = {} }) => {
    const dateFrom = useMemo(
        () => content.available_from ? format(new Date(content.available_from), FORMAT_DATE) : null,
        [content.available_from],
    );
    const dateTo = useMemo(
        () => content.available_to ? format(new Date(content.available_to), FORMAT_DATE) : null,
        [content.available_to],
    );

    return (
        <div className={styles.dates}>
            {dateFrom && <div className={styles.dates__row}>{dateFrom}</div>}
            {dateFrom && dateTo && <span className={styles.dates__dash}>–</span>}
            {dateTo && (
                <div className={`${styles.dates__row} ${content.isExpired ? styles.expired : ""}`}>
                    {dateTo}
                </div>
            )}
        </div>
    );
};

export default AvailableDateData;
